<template>
  <div>
    <!-- IP 관리 범위 목록 -->
    <div>
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">IP 관리 범위 목록</div>
          <div class="setting-addel">
            <el-button size="mini" @click="openAddPopup"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" @click="onDeleteButton" :disabled="!checkedRows.length"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
        <div class="vertical-center-box">
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :height="305" :column-default="columnDefault" :data="tableData" :columns="tableColumns" highlight-current-row row-class-name="c-dblclick" :pagination="false"
      ref="ipRangeTable" :show-search-tool="showSearchTool" :show-custom-header="true" remote @row-click="onRowClick" @row-dblclick="onRowDblclick" @selection-change="onSelectionChange" @condition-change="loadData">
      </el-table-wrapper>
    </div>
    <!-- IP 테이블 -->
    <div>
      <w-ip-table class="mr-t25" :selected-row="selectedRow" ref="ipTable"></w-ip-table>
    </div>
    <w-add-ip-range-popup :selected-node="selectedNode" :popup-params="popupParams" ref="addIpRangePopup" @re-load="loadData"/>
  </div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import provisioningSettingApi from '@/api/settings/virtual/provisioning-settings';
import WIpTable from './IpTable';
import WAddIpRangePopup from '../popup/AddIpRangePopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WHostIpRangeTable',
  components: {
    WIpTable,
    WAddIpRangePopup,
  },
  props: {
    selectedNode: {
      type: Object,
    },
    isLeaf: {
      type: Boolean,
    },
  },
  data() {
    const tableColumns = [
      {
        align: 'center',
        type: 'selection',
      },
      {
        prop: 'gateway',
        label: '게이트웨이',
        formatter: defaultFormatter,
        searchable: true,
        sortable: true,
      },
      {
        prop: 'subnet',
        label: '서브넷 마스크',
        formatter: defaultFormatter,
        searchable: true,
        sortable: true,
      },
      {
        prop: 'dns',
        label: 'DNS',
        formatter: defaultFormatter,
        searchable: true,
        sortable: true,
      },
      {
        prop: 'startIpaddress',
        label: '시작 IP',
        formatter: defaultFormatter,
        searchable: true,
        sortable: true,
      },
      {
        prop: 'endIpaddress',
        label: '종료 IP',
        formatter: defaultFormatter,
        searchable: true,
        sortable: true,
      },
      {
        prop: 'totalCount',
        label: '전체',
        formatter: defaultFormatter,
      },
      {
        prop: 'userate',
        label: '사용률',
        formatter: (row, column, value) => {
          if (isNil(value)) return EMPTY_TEXT;
          const percentage = Number(value) * 100;
          return `${parseFloat(percentage).toFixed(2)}%`;
        },
      },
      {
        prop: 'usedCount',
        label: '사용',
        formatter: defaultFormatter,
      },
      {
        prop: 'unusedCount',
        label: '미사용',
        formatter: defaultFormatter,
      },
    ];
    return {
      popupParams: {},
      tableData: [],
      tableColumns,
      checkedRows: [],
      selectedRow: null,
      showSearchTool: false,
      columnDefault,
    };
  },
  watch: {
    selectedNode() {
      if (this.isLeaf) {
        this.loadData();
        this.$nextTick(() => {
          this.$refs.ipTable.clearIpTable();
        });
      }
    },
  },
  methods: {
    loadData() {
      const ipRangeTable = this.$refs.ipRangeTable;
      const tableParams = ipRangeTable.getParameter();
      const hostId = this.selectedNode.treeKey.split('.')[1];
      provisioningSettingApi.getHostIpRangeList({
        hostId: Number(hostId),
        ...tableParams,
      }).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          if (this.tableData.length > 0) {
            const firstRow = this.tableData[0];
            ipRangeTable.getTable().setCurrentRow(firstRow);
            this.onRowClick(firstRow);
          } else {
            this.onRowClick(null);
          }
        }
      });
    },
    onDeleteButton() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = 'IP 관리범위';
        const action = msgUtil.action.DELETE;
        provisioningSettingApi.deleteVmsHostIpRangeList(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
    openAddPopup() {
      this.popupParams = { popupType: 'ADD' };
      this.$refs.addIpRangePopup.open();
    },
    onRowClick(row) {
      if (isNil(this.selectedRow) || isNil(row) || this.selectedRow.rangeId !== row.rangeId) {
        this.selectedRow = row;
        this.$nextTick(() => {
          this.$refs.ipTable.loadData();
        });
      }
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    onRowDblclick(row) {
      this.popupParams = {
        popupType: 'UPDATE',
        selectedRow: cloneDeep(row),
      };
      this.$refs.addIpRangePopup.open();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/IpRangeSetting/components/HostIpRangeTable.vue